// import {getEnd} from './utils';
const SUPPORT_COUNTRY = {
  BR: 'Br',
  MX: 'Mx',
  CO: 'Mx',
  CL: 'Mx',
  PE: 'Mx',
  CR: 'Mx',
  PA: 'Mx',
  AU: 'Au',
  EC: 'Mx',
  DO: 'Mx',
  PR: 'Mx',
  RU: 'Mx',
  AR: 'Mx',
  NZ: 'Au',
  ZA: 'Mx',
  UA: 'Mx',
};
const SUPPORT_COUNTRY_CONFIG = {
  BR: {
    lang: 'pt-BR',
    locale: 'pt-BR',
  },
  MX: {
    lang: 'es-MX',
    locale: 'es-MX',
  },
  CO: {
    lang: 'es-CO',
    locale: 'es-CO',
  },
  CL: {
    lang: 'es-419',
    locale: 'es-419',
  },
  PE: {
    lang: 'es-419',
    locale: 'es-419',
  },
  CR: {
    lang: 'es-419',
    locale: 'es-419',
  },
  PA: {
    lang: 'es-419',
    locale: 'es-419',
  },
  EC: {
    lang: 'es-419',
    locale: 'es-419',
  },
  PR: {
    lang: 'es-419',
    locale: 'es-419',
  },
  DO: {
    lang: 'es-419',
    locale: 'es-419',
  },
  AU: {
    lang: 'en-US',
    locale: 'en-US',
  },
  RU: {
    lang: 'ru-RU',
    locale: 'ru-RU',
  },
  AR: {
    lang: 'es-419',
    locale: 'es-419',
  },
  NZ: {
    lang: 'en-AU',
    locale: 'en-AU',
  },
  ZA: {
    lang: 'en-AU',
    locale: 'en-AU',
  },
  UA: {
    lang: 'uk-UA',
    locale: 'uk-UA',
  },
};
const OLD_REGISTER_URL = {
  BR: 'https://page.99taxis.mobi/common/register',
  MX: 'https://page.didiglobal.com/global/driver/apps/register',
  AU: 'https://page.didiglobal.com/global/register/apac-driver/index.html',
};
let up = new URLSearchParams (location.search);
const SOURCE = {
  web: '',
  fleetApp: 'com.app99.fleet',
  fleet: 'com.didiglobal.fleet',
  global: 'com.didiglobal.driver',
  globalIos: 'com.didi.global.driver',
  br_99: 'com.app99.driver',
  global_au: 'com.didiglobal.driver.au',
  minibus_new: 'com.didiglobal.bus',
  minibus_old: 'com.didiglobal.driver.bus',
};

const ends = {
  inApp: !!Fusion.pickImage,
  isFleet: up.get ('bundle_id') === SOURCE.fleet,
  isFleetApp: up.get('bundle_id') === SOURCE.fleetApp,
  isGlobal: (up.get ('bundle_id') || '').indexOf (SOURCE.global) > -1,
  isIOS: /(iPhone|iPad|iPod|iOS)/i.test (navigator.userAgent),
  isAndroid: /(Android)/i.test (navigator.userAgent),
  isPC: up.get ('from') === 'official_site',
  isPassengerTerminal: !!((/(iPhone|iPad|iPod|iOS)/i.test (
    navigator.userAgent
  ) &&
    up.get ('datatype') == 101) ||
    (/(Android)/i.test (navigator.userAgent) && up.get ('datatype') == 1)),
};

const LOGIN_CONFIG = {
  COMMON: {
    appid: 70012,
    role: 2,
    city_id: 0,
    lang: 'es-MX',
    imei: up.get ('deviceid') || '',
    extra_info: {
      oid: Omega.getOmgid (),
      channel: up.get ('channel'),
      end: getEnd (),
      aid: up.get ('aid'),
      frid: up.get('frid'),
    },
    styleObj:{
      btn: {
        activeColor: '#fff',
        bgColor: '#FF7226',
      },
    }
  },
  BR_oasis: {
    styleObj: {
      btn: {
        activeColor: '#000',
        bgColor: 'linear-gradient(135deg, #FFF362 0%, #FD9728 100%)',
      },
    },
    appid: 120004,
    role: 1,
    lang: 'pt-BR',
    country_id: 76,
    country_calling_code: '+55',
    canonical_country_code: 'BR',
  },
  BR: {
    appid: 70014,
    lang: 'pt-BR',
    country_id: 76,
    country_calling_code: '+55',
    canonical_country_code: 'BR',
    law_url: 'https://common.didiglobal.com/common/v6/driver/law?location_country=BR&lang=pt-BR',
    styleObj: {
      btn: {
        disableColor: '#999999',
        activeColor: '#333333',
        bgColor: 'yellow',
      },
      law: {
        color: '#2697FF',
        iconBlue: true,
        marginRight: '12px',
      },
    },
  },
  Global_oasis: {
    role: 1,
    appid: 120776
  },
  MX: {
    country_id: 484,
    country_calling_code: '+52',
    canonical_country_code: 'MX',
  },
  MX_minibus: {
    appid: 120798,
    role: 2357,
    lang: 'es-MX',
    country_id: 484,
    country_calling_code: '+52',
    canonical_country_code: 'MX',
  },
  CO: {
    country_id: 170,
    country_calling_code: '+57',
    canonical_country_code: 'CO',
  },
  CL: {
    country_id: 152,
    country_calling_code: '+56',
    canonical_country_code: 'CL',
  },
  PE: {
    country_id: 604,
    country_calling_code: '+51',
    canonical_country_code: 'PE',
  },
  CR: {
    country_id: 188,
    country_calling_code: '+506',
    canonical_country_code: 'CR',
  },
  PA: {
    country_id: 591,
    country_calling_code: '+507',
    canonical_country_code: 'PA',
  },
  EC: {
    country_id: 218,
    country_calling_code: '+593',
    canonical_country_code: 'EC',
  },
  DO: {
    country_id: 212,
    country_calling_code: '+1',
    canonical_country_code: 'DO',
  },
  PR: {
    country_id: 630,
    country_calling_code: '+1',
    canonical_country_code: 'PR',
  },
  AU: {
    country_calling_code: '+61',
    country_id: 36,
    lang: 'en-US',
    canonical_country_code: 'AU',
  },
  RU: {
    showCusJP: true,
    country_calling_code: '+7',
    country_id: 643,
    lang: 'ru-RU',
    canonical_country_code: 'RU',
  },
  AR: {
    country_calling_code: '+54',
    country_id: 32,
    canonical_country_code: 'AR',
  },
  NZ: {
    country_calling_code: '+64',
    country_id: 554,
    lang: 'en-US',
    canonical_country_code: 'NZ',
  },
  ZA: {
    country_calling_code: '+27',
    country_id: 710,
    lang: 'en-US',
    canonical_country_code: 'ZA',
  },
  EG: {
    country_calling_code: '+20',
    country_id: 818,
    lang: 'ar-EG',
    isRTL: true, //是否镜像
    canonical_country_code: 'EG',
  },
  UA: {
    country_calling_code: '+380',
    country_id: 804,
    lang: 'uk-UA',
    canonical_country_code: 'UA',
    law_url: 'https://common.didiglobal.com/common/v6/driver/law?location_country=UA&lang=uk-UA',
  },
};

const IOS_MAP_URL = 'https://maps.apple.com/';
const ANDROID_MAP_URL = 'https://maps.google.com/maps';

//todo notes 其他三国电话
// const SERVICE_PHONE = {
//   MX: '018007258888',
//   CO: '4049000',
//   CL: '229389302',
//   PE: '7094900',
//   CR: '40023814',
// };

const SERVICE_PHONE = {
  AU: '1800 413 678',
  AR: '1139876342',
  BR: '0300 313 2421',
  CL: '233040932',
  CO: '0317940362',
  CR: '41046048',
  DO: '18299462209',
  MX: '18007258888',
  PA: '(+507) 471 9996',
  PE: '15102783',
  EC: '(+593) 234 22606',
  EG: '20-1501718027',
  KZ: '88000040008',
  RU: '88002341001',
  UA: '800808881'
};

// 线上存量国家
const OPEN_COUNTRY = ['BR', 'AU', 'RU', 'PR', 'NZ', 'KZ', 'UA']

function getEnd () {
  let up = new URLSearchParams (location.search);
  const bundle_id = up.get ('bundle_id') || '';
  let end = 'WebEnd'; // 手机浏览器
  if (bundle_id.indexOf (SOURCE.fleet) > -1) {
    end = 'FleetEnd'; // 手机Fleet
  } else if (bundle_id.indexOf (SOURCE.global) > -1) {
    end = 'DriverEnd'; // 手机司机端(Android)
  } else if (bundle_id.indexOf (SOURCE.br_99) > -1) {
    end = 'DriverEnd'; // 手机司机端
  } else if (bundle_id.indexOf (SOURCE.globalIos) > -1) {
    end = 'DriverEnd'; // 手机司机端(ios)
  } else if (bundle_id.indexOf (SOURCE.minibus_new) > -1 || bundle_id.indexOf (SOURCE.minibus_old) > -1) {
    end = 'DriverEnd'; // 小巴司机端
  } else if (
    (ends.isIOS && up.get ('datatype') == 101) ||
    (ends.isAndroid && up.get ('datatype') == 1)
  ) {
    //乘客端
    end = 'PassengerEnd';
  } else if (ends.isPC) {
    //官方网站
    end = 'PCEnd';
  }
  return end;
}

const AREA_TYPE = {
  'select': {
    state: '_area',
    state_open_type: '_open_type',
  },
  'select_county': {
    state: '_city',
    state_open_type: '_city_open_type',
  }
}

export {
  SUPPORT_COUNTRY,
  SUPPORT_COUNTRY_CONFIG,
  ends,
  SOURCE,
  OLD_REGISTER_URL,
  LOGIN_CONFIG,
  IOS_MAP_URL,
  ANDROID_MAP_URL,
  SERVICE_PHONE,
  OPEN_COUNTRY,
  AREA_TYPE
};
